// import packags and folders

import Ss3 from './Math'
import Header from '../../../headfoot/Header'

export default function ClassNotes() {
  return (
    <div>
      <Header />
      <div className="pt-20">
        <Ss3 />
      </div>
    </div>
  )
}
